<template>
	<div class="goods">
	  <v-head :title="title"></v-head>
	   <!--<div class="imgBox">
	   	 <img src="../../assets/images/Membership.jpg">
	   </div>-->
		<!-- 团体会员 -->
		<div v-if="isGroupMember">
			<div class="car-box group-box" id="card" v-cloak>
				<ul>
					<!-- <li>{{userInfo.memberNo}}</li>
					<li
							:class="{'smallBottom':userInfo.company&&userInfo.company.length > 15}"
					>{{userInfo.name || '--'}}</li>
					<li>{{compare(userInfo.memberType)}}</li> -->
					<li>{{userInfo.expiryDate | limitDate}}</li>
					<!-- <li>{{componentName}}</li> -->
				</ul>
			</div>
		</div>
		<!-- 个人会员 -->
		<div v-else>
			<div class="car-box isSSOC" id="card" v-cloak>
				<template v-if="userInfo.portraitId">
					<div class="portrait" id="demo" :style="{backgroundImage:'url(' + PZUrl + ')'}"></div>
				</template>
				<ul>
					<li>{{userInfo.memberNo}}</li>
					<li
							:class="{'smallBottom':userInfo.company&&userInfo.company.length > 15}"
					>{{userInfo.name || '--'}}</li>
					<li>{{userInfo.company}}</li>
					<li>{{compare(userInfo.memberType)}}</li>
					<li>{{userInfo.expiryDate | limitDate}}</li>
					<li>{{componentName}}</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
import {
	getUser,
	baseURL,
	getPortrait,
	getPZUrl,
	getAssociationCurrent,
	getDictionaryByCode,
	getDuesList
} from "@/api/dictionary";
import vHead from "../../components/Subhead.vue";
import { Uploader,Toast,Button } from "vant";
import { mapGetters, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
     title:"电子会员证",
     fileList: [],
     photoList:[],
	userInfo: {
		id: "",
		name: "未登录",
		memberTypes:''
	},
	cardName: "card.png",
	componentName: "",
	cardUrl: "",
	PZUrl: "", //头像地址
	singerList:[]
    };
  },

  components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button
  },
	computed: {
		...mapGetters(["commond", "isGroupMember"])
	},
	methods: {
		getAssociationCurrent() {
			getAssociationCurrent().then(res => {
				if (res.success) {
					this.componentName = res.result.name;
				}
			});
		},
		getDisplay(id) {
			getPZUrl({ id }).then(res => {
				if (res.success) {
					this.PZUrl = res.result;
				}
			});
		},
		getSingerList(params){
			getDictionaryByCode(params)
				.then(res =>{
					this.singerList = res.result;
				})
		},
		compare(value){
			var obj = this.singerList.filter(function(item){
				return item.value == value;
			});
			if(!obj.length) return '网员';
			return obj[0].name;
		},
		getUser() {
			return new Promise((resolve, reject) => {
				getUser()
						.then(data => {
							this.userInfo = data.result;
							if(this.userInfo.memberCategory == 1){
								this.getSingerList('MEMBER_TYPE');
							}else{
								this.getSingerList('GROUP_TYPE');
							}
							resolve(data.result);
						})
						.catch(() => {
							this.$message.error("获取用户信息失败！");
						});
			});
		}
	},
	mounted: async function() {
		let data = await this.getUser();
		this.getAssociationCurrent();
		this.cardName = data.name + data.memberNo + ".png";
		this.getDisplay(data.portraitId);
	}
};
</script>

<style  lang="less" scoped>
.imgBox{
	padding:20px;
    img{ width: 100%; }
}
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
.nav-title {
	display: flex;
	color: #228ccd;
	font-weight: bold;
	align-items: center;
	img {
		width: 17px;
		margin-right: 12px;
	}
}
.car-box.isSSOC {
	position: relative;
	margin: 10px auto 0;
	height:540px;
	background: url("../../assets/images/Membership.jpg") center no-repeat;
	background-size: 94%;
}
.car-box.isSSOC ul {
	width: 190px;
	position: absolute;
	top: 290px;
	margin-left: 122px;
	text-align: center;
	line-height: 18px;
}
.group-box {
	position: relative;
	width: 400px;
	height: 280px;
	// margin: 20px auto 0;
	background: url("../../assets/images/group-card.jpg") 0 0 / contain
	no-repeat;
	background-size: cover;
	transform: rotate(90deg);
	margin-top: 194px;
    margin-left: -14px;
}
.car-box.group-box ul {
	width: 190px;
	margin-left: 122px;
	padding-top: 280px;
	text-align: center;
	line-height: 18px;
}
.car-box ul li.smallBottom {
	margin-bottom: 5px !important;
}
.portrait {
	position: absolute;
	width: 100px;
	height: 126px;
	display: block;
	left: 0;
	right: 0;
	margin: 0 auto;
	top: 132px;
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
}
.car-box ul li {
	min-height: 18px;
	margin-bottom: 17px;
}
.group-box ul li {
	min-height: 18px;
	margin-bottom: 17px;
    margin-left: 20px;
    margin-top: -68px;
    font-weight: 600;
    color: #302929;
    font-size: 5px;
    width: 300px;
}
.btn {
	display: block;
	width: 110px;
	height: 38px;
	margin: 38px auto 0;
	font-size: 14px;
	line-height: 38px;
	text-align: center;
	color: #fff;
	border-radius: 3px;
	background: #228ccd;
	cursor: pointer;
}
.btn:active {
	background: #1a6fa3;
}
</style>